import { markRaw } from 'vue'
import HeroView from './HeroView.vue'
import schema from './schema'
import uiSchema from './ui-schema'

export default {
  viewComponent: markRaw(HeroView),
  editorSchema: schema,
  editorUISchema: uiSchema,
  editorData: {
    slogan: 'Your event starts here',
    sloganMaxWidth: 576,
    sloganTextGap: 32,
    sloganTextAlign: 'center',
    sloganFontSize: 'text-3xl',
    sloganFontFamily: 'Montserrat',
    text: '# Getting acquainted \n\n The client briefs us about the company, the project, and the team, describes the tasks faced and the ideal candidate.',
    textColor: '#ffffff',
    textFontSize: 'text-xl',
    textAlign: 'center',
    logoAlign: 'left',
    paddingSize: 'md',
    isBgImage: true,
    bgColor: '#000000',
    bgImage: 'https://cdn.wnhub.io/39253/65dde526e1a6c4.93735968.jpg',
    buttons: [],
    maxWidth: 576,
  },
}
